import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "scroll-container" }
const _hoisted_3 = {
  key: 0,
  class: "iframe-wrapper"
}
const _hoisted_4 = ["src"]

import { onMounted, provide, ref, watch } from 'vue';
// import { PWARewardAPI } from './api/user';
import { getPWADomainInfo } from './api/common';
import { useRoute } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const isStandalone = ref(false);
const App_URL = ref('')

onMounted(() => {
  // Detect standalone
  if (window.matchMedia("(display-mode: standalone)").matches) {
    isStandalone.value = true;
  } else if ((window.navigator as any).standalone) {
    // iOS Safari PWA
    isStandalone.value = true;
  }

  // React to changes
  window.matchMedia("(display-mode: standalone)")
    .addEventListener("change", (e) => {
      isStandalone.value = e.matches;
    });

  // 🔹 Detect PWA installation and refresh
  window.addEventListener("appinstalled", () => {
    console.log("✅ PWA was installed");
    window.location.reload(); // refresh app instantly
    if (localStorage.getItem('token') && localStorage.getItem('clientId')) {
      pwaCliam()
    }
    clearAuthData();
  });
});

const pwaCliam = () => {
  // PWARewardAPI().then(res => {
    console.log("claim success: ");
  //   clearAuthData();
  // }).catch(err => {
  //   console.log("claim err: ", err);
  //   clearAuthData();
  // })
}


const getPWAInfo = () => {
  getPWADomainInfo().then(res => {
    let domain = res.data.websiteDomain
    if (domain && !domain.startsWith("http")) {
      domain = "https://" + domain
    }
    App_URL.value = domain
  }).catch(err => {
    console.log("claim err: ", err);

  })
};
const clearAuthData = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("clientId");
  localStorage.removeItem("tenantId");
};


onMounted(() => {
  getPWAInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isStandalone.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("iframe", {
              src: App_URL.value,
              class: "masked-iframe"
            }, null, 8, _hoisted_4)
          ]))
        : (_openBlock(), _createBlock(_Transition, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_RouterView)
            ]),
            _: 1
          }))
    ])
  ]))
}
}

})